import { Routes } from '@angular/router';
import { inject } from '@angular/core';
import { InventoryService } from './services/inventory.service';
import {
  DefaultInventoryRepository,
  SOFTLINE_MDE_INVENTORY_REPOSITORY,
} from './repositories/inventory.repository';
import { ApiDataAccess } from '@softline/core';
import { InventoryItemService } from './services/inventory-item.service';
import {
  DefaultInventoryItemRepository,
  SOFTLINE_MDE_INVENTORY_ITEM_REPOSITORY,
} from './repositories/inventory-item.repository';
import {
  DefaultInventoryProductDetailRepository,
  SOFTLINE_MDE_INVENTORY_PRODUCT_DETAIL_REPOSITORY,
} from './repositories/inventory-product-detail.repository';
import { inventoryResolveFn } from './resolvers/inventory.resolver';
import { InventoryConfigService } from './services/inventory-config.service';
import { RemoteConfigResolver } from '@softline/application';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';

export const mdeInventoryRoutes: Routes = [
  {
    path: 'mde-inventur',
    providers: [
      InventoryConfigService,
      {
        provide: SOFTLINE_MDE_INVENTORY_REPOSITORY,
        useFactory: () => new DefaultInventoryRepository(inject(ApiDataAccess)),
      },
      {
        provide: SOFTLINE_MDE_INVENTORY_ITEM_REPOSITORY,
        useFactory: () => new DefaultInventoryItemRepository(inject(ApiDataAccess)),
      },
      {
        provide: SOFTLINE_MDE_INVENTORY_PRODUCT_DETAIL_REPOSITORY,
        useFactory: () =>
          new DefaultInventoryProductDetailRepository(inject(ApiDataAccess)),
      },
      {
        provide: InventoryService,
        useFactory: () => new InventoryService(),
      },
      {
        provide: InventoryItemService,
        useFactory: () => new InventoryItemService(),
      },
    ],
    canActivate: [AuthorizationGuard, AuthenticationGuard],
    canDeactivate: [
      () => {
        const inventoryService = inject(InventoryService);
        inventoryService.reset();
        return true;
      },
    ],
    children: [
      {
        path: 'start',
        loadComponent: () => import('./pages/start/start.component'),
      },
      {
        path: 'add',
        resolve: {
          activeInventory: inventoryResolveFn,
        },
        loadComponent: () => import('./pages/add/add.component'),
        children: [
          {
            path: 'search',
            loadComponent: () => import('./pages/add/search/search.component'),
          },
          {
            path: ':productId',
            loadComponent: () => import('./pages/add/form/form.component'),
          },
          {
            path: '**',
            redirectTo: '/mde-inventur/add/search',
          },
        ],
      },
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./pages/main/main.component'),
        resolve: {
          activeInventory: inventoryResolveFn,
          config: RemoteConfigResolver,
        },
      },
    ],
  },
];
